import { Button } from '@xprog/prensa'
import { ButtonProps } from '@xprog/prensa/types'
import { FilterContext } from 'providers/Filter'
import React, { useContext } from 'react'

export interface DivisorTabsButtonProps extends ButtonProps {
  children?: string;
  numberValue?: string;
  pageBlockId?: string;
  slotTemplateId?: string;
}

const DivisorTabsButton: React.FC<DivisorTabsButtonProps> = ({ children, pageBlockId, slotTemplateId, numberValue, ...otherProps }) => {
  const { sideBoxFilter, updateSideBoxFilter } = useContext(FilterContext)
  const selected = sideBoxFilter === numberValue

  const styles = {
    button: {
      border: '1px solid #E6E6E6',
      borderTopLeftRadius: '$alternative',
      borderTopRightRadius: '$alternative',
      minHeight: selected ? '59px' : '49px',
      padding: '0px',
      width: '50%'
    },
    label: {
      color: selected ? '$basicBlack' : '#A6A6A6',
      fontFamily: '$primary',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '26px'
    }
  }

  const handleClick = () => {
    updateSideBoxFilter(numberValue || '1')
  }

  return (
    <Button
      css={styles}
      onClick={handleClick}
      variant='ghost'
      labelSpacing={0}
      {...otherProps}
    >
      {children}
    </Button>
  )
}

export default DivisorTabsButton